{
  "GENERAL_SETTINGS": {
    "LIMIT_MESSAGES": {
      "CONVERSATION": "Вы превысили лимит диалогов. Тариф Hacker допускает не более 500 диалогов.",
      "INBOXES": "Вы превысили лимит источников. Тариф Hacker поддерживает только веб-чат на сайте. Дополнительные источники, такие как email, WhatsApp и т. д., требуют платного тарифа.",
      "AGENTS": "Вы превысили лимит агентов. Тариф Hacker допускает не более 2 агентов.",
      "NON_ADMIN": "Пожалуйста, обратитесь к администратору, чтобы обновить тариф и продолжить пользоваться всеми функциями."
    },
    "TITLE": "Настройки аккаунта",
    "SUBMIT": "Изменить настройки",
    "BACK": "Назад",
    "DISMISS": "Отклонить",
    "UPDATE": {
      "ERROR": "Не удалось обновить настройки, попробуйте снова!",
      "SUCCESS": "Настройки аккаунта обновлены"
    },
    "ACCOUNT_DELETE_SECTION": {
      "TITLE": "Удалить ваш аккаунт",
      "NOTE": "После удаления аккаунта все ваши данные будут удалены.",
      "BUTTON_TEXT": "Удалить ваш аккаунт",
      "CONFIRM": {
        "TITLE": "Удалить аккаунт",
        "MESSAGE": "Удаление аккаунта необратимо. Введите название вашего аккаунта ниже, чтобы подтвердить, что вы хотите удалить его безвозвратно.",
        "BUTTON_TEXT": "Удалить",
        "DISMISS": "Отменить",
        "PLACE_HOLDER": "Введите {accountName} для подтверждения"
      },
      "SUCCESS": "Аккаунт помечен для удаления",
      "FAILURE": "Не удалось удалить аккаунт, попробуйте ещё раз!",
      "SCHEDULED_DELETION": {
        "MESSAGE_MANUAL": "Этот аккаунт запланирован к удалению {deletionDate}. Это было запрошено администратором. Вы можете отменить удаление до этой даты.",
        "MESSAGE_INACTIVITY": "Этот аккаунт запланирован к удалению {deletionDate} из-за неактивности. Вы можете отменить удаление до этой даты.",
        "CLEAR_BUTTON": "Отменить запланированное удаление"
      }
    },
    "FORM": {
      "ERROR": "Пожалуйста исправьте ошибки",
      "GENERAL_SECTION": {
        "TITLE": "Общие настройки",
        "NOTE": ""
      },
      "ACCOUNT_ID": {
        "TITLE": "ID аккаунта",
        "NOTE": "Этот ID требуется для построения интеграции, основанной на API"
      },
      "NAME": {
        "LABEL": "Имя аккаунта",
        "PLACEHOLDER": "Имя вашего аккаунта",
        "ERROR": "Пожалуйста, введите корректное имя аккаунта"
      },
      "LANGUAGE": {
        "LABEL": "Язык сайта",
        "PLACEHOLDER": "Имя вашего аккаунта",
        "ERROR": ""
      },
      "DOMAIN": {
        "LABEL": "Домен входящей почты",
        "PLACEHOLDER": "Домен, на который вы принимаете письма",
        "ERROR": ""
      },
      "SUPPORT_EMAIL": {
        "LABEL": "Email поддержки",
        "PLACEHOLDER": "Email службы поддержки вашей компании",
        "ERROR": ""
      },
      "AUTO_RESOLVE_DURATION": {
        "LABEL": "Количество дней после того, как тикет будет автоматически решен, если нет активности",
        "NOTE": "Количество часов бездействия, после которых любой открытый диалог будет автоматически решён.",
        "PLACEHOLDER": "30",
        "ERROR": "Введите корректную длительность для автозавершения диалога (минимум 1 день, максимум 999)"
      },
      "AUTO_RESOLVE_EMPTY_DURATION": {
        "LABEL": "Количество дней, после которых пустой диалог должен автоматически решаться при отсутствии активности",
        "PLACEHOLDER": "никогда",
        "ERROR": "Пожалуйста, укажите корректный срок автоматического решения пустых диалогов (от 1 до 999 дней)"
      },
      "FEATURES": {
        "INBOUND_EMAIL_ENABLED": "Для вашего аккаунта включено продолжение диалогов по электронной почте.",
        "CUSTOM_EMAIL_DOMAIN_ENABLED": "Теперь вы можете получать письма на свой домен."
      },
      "PHONE": {
        "TITLE": "Настройки PBX",
        "NOTE": "Настройте подключение к вашей PBX для телефонных звонков",
        "SIP_HOST": {
          "LABEL": "Домен SIP"
        },
        "DIALING_MODE": {
          "LABEL": "Режим набора номера",
          "MODES": {
            "direct": "Прямой — звонок совершается сразу при нажатии на телефонную ссылку",
            "indirect": "Непрямой — номер телефона подготавливается в поле ввода виджета телефона"
          }
        },
        "CALL_RECORDING_ACCESS": {
          "LABEL": "Доступ к записям звонков",
          "MODES": {
            "admin_only": "Только администраторы",
            "admin_and_assigned_agent": "Администраторы и назначенный агент",
            "inbox_members": "Все агенты с доступом к источнику"
          }
        }
      },
      "EMAIL": {
        "TITLE": "Настройки email",
        "NOTE": "Изменяет поведение почтовых источников"
      },
      "CONVERSATION_TIMESTAMP_DISPLAY_MODE": {
        "LABEL": "Режим отображения времени диалога",
        "MODES": {
          "both": "Создание и последняя активность",
          "last_activity_only": "Только последняя активность",
          "last_customer_message": "Последнее сообщение клиента"
        }
      },
      "BLOCK_DOMAINS_WITH_LOW_REPUTATION": {
        "LABEL": "Блокировать домены с низкой репутацией"
      },
      "INCLUDE_PREVIOUS_EMAIL_MESSAGE": {
        "LABEL": "Включать исходное сообщение в ответ на email"
      },
      "RESOLVE_NEW_CONVERSATION": {
        "LABEL": "Автоматически решать новый диалог"
      },
      "MOVE_CONVERSATIONS_BY_ORDERS": {
        "LABEL": "Автоматически перемещать новый разговор по e-mail во входящие робота, который обработал заказы контакта"
      },
      "EXTENDED_LABELS": {
        "LABEL": "Расширенные метки — разрешить более длинные названия меток с увеличенным всплывающим интерфейсом"
      },
      "ENABLE_LAST_AGENT": {
        "LABEL": "LastAgent — автоматически назначать диалог агенту, создавшему последний ответ"
      },
      "PUSH_NOTIFICATION_MODE": {
        "LABEL": "Режим push-уведомлений",
        "MODES": {
          "all_inboxes": "Все источники — отправлять уведомления для всех типов каналов",
          "chat_only": "Только чат — отправлять уведомления только для каналов, отличных от email"
        }
      },
      "ALLOW_TOGGLE_SIGNATURE": {
        "LABEL": "Разрешить включать и выключать подпись в отправленных сообщениях"
      },
      "WALLBOARD_CHAT_STATUS_ENABLED": {
        "LABEL": "Показывать статус чата агента на wallboard"
      },
      "SHOW_FULL_ATTACHMENT_NAMES": {
        "LABEL": "Показывать полные названия вложений без сокращения"
      },
      "PASSWORD_LOGIN_MODE": {
        "LABEL": "Вход по паролю",
        "MODES": {
          "allowed_for_all": "Разрешено для всех пользователей",
          "allowed_for_agents_only": "Разрешено только для агентов (администраторы должны использовать OAuth)",
          "password_login_disabled": "Отключено — только OAuth"
        }
      }
    },
    "NEW_VERSION_AVAILABLE": "Доступна новая версия. Перезагрузите страницу, чтобы получить последние обновления.",
    "RELOAD_NOW": "Обновить сейчас",
    "LEARN_MORE": "Узнайте больше",
    "PAYMENT_PENDING": "Ваш платеж в ожидании. Пожалуйста, обновите платежную информацию, чтобы продолжить использовать контакт-центр",
    "LIMITS_UPGRADE": "Превышен лимит использования вашего тарифного плана, пожалуйста, обновите тарифный план, чтобы продолжить использовать контакт-центр",
    "OPEN_BILLING": "Открыть платеж"
  },
  "FORMS": {
    "MULTISELECT": {
      "ENTER_TO_SELECT": "Нажмите Enter для выбора",
      "ENTER_TO_REMOVE": "Нажмите Enter для удаления",
      "NO_OPTIONS": "Список пуст",
      "NO_RESULT": "Ничего не найдено",
      "SELECT_ONE": "Выберите один",
      "SELECT": "Выбрать"
    }
  },
  "NOTIFICATIONS_PAGE": {
    "HEADER": "Уведомления",
    "MARK_ALL_DONE": "Отметить все прочитанными",
    "DELETE_TITLE": "удалено",
    "UNREAD_NOTIFICATION": {
      "TITLE": "Непрочитанные уведомления",
      "ALL_NOTIFICATIONS": "Показать все уведомления",
      "LOADING_UNREAD_MESSAGE": "Загрузка непрочитанных уведомлений...",
      "EMPTY_MESSAGE": "У вас нет непрочитанных уведомлений"
    },
    "LIST": {
      "LOADING_MESSAGE": "Загрузка уведомлений...",
      "404": "Уведомления отсутствуют",
      "TABLE_HEADER": [
        "Имя",
        "Номер телефона",
        "Диалоги",
        "Последний Контакт"
      ]
    },
    "TYPE_LABEL": {
      "conversation_creation": "Новая беседа",
      "conversation_assignment": "Беседа назначена",
      "assigned_conversation_new_message": "Новое сообщение",
      "participating_conversation_new_message": "Новое сообщение",
      "conversation_mention": "Упоминание",
      "sla_missed_first_response": "Пропущено SLA",
      "sla_missed_next_response": "Пропущено SLA",
      "sla_missed_resolution": "Пропущено SLA"
    }
  },
  "NETWORK": {
    "NOTIFICATION": {
      "OFFLINE": "Оффлайн",
      "RECONNECTING": "Повторное подключение:",
      "RECONNECT_SUCCESS": "Повторное подключение успешно"
    },
    "BUTTON": {
      "REFRESH": "Обновить"
    },
    "CONNECTION_LOST": {
      "TITLE": "Соединение потеряно",
      "DESCRIPTION": "Не удалось подключиться к серверу. Проверьте соединение и повторите попытку.",
      "RETRY": "Повторить попытку"
    }
  },
  "COMMAND_BAR": {
    "SEARCH_PLACEHOLDER": "Искать или перейти к",
    "SECTIONS": {
      "GENERAL": "Главное",
      "REPORTS": "Отчёты",
      "CONVERSATION": "Диалоги",
      "BULK_ACTIONS": "Массовые действия",
      "CHANGE_ASSIGNEE": "Изменить Назначенного",
      "CHANGE_PRIORITY": "Изменить приоритет",
      "CHANGE_TEAM": "Изменить команду",
      "SNOOZE_CONVERSATION": "Включить звук диалога",
      "EXECUTE_MACRO": "Выполнить макрос",
      "ADD_LABEL": "Добавить метку в диалог",
      "REMOVE_LABEL": "Удалить метку из диалога",
      "SETTINGS": "Настройки",
      "AI_ASSIST": "Помощь ИИ",
      "APPEARANCE": "Образец",
      "SNOOZE_NOTIFICATION": "Отложить уведомление"
    },
    "COMMANDS": {
      "GO_TO_CONVERSATION_DASHBOARD": "Перейти к панели разговоров",
      "GO_TO_CONTACTS_DASHBOARD": "Перейти к панели контактов",
      "GO_TO_REPORTS_OVERVIEW": "Перейти к обзору отчетов",
      "GO_TO_CONVERSATION_REPORTS": "Перейти к отчетам по диалогам",
      "GO_TO_AGENT_REPORTS": "Перейти к отчетам по сотрудникам",
      "GO_TO_LABEL_REPORTS": "Перейти к отчетам по меткам",
      "GO_TO_INBOX_REPORTS": "Перейти к отчётам по «Входящим»",
      "GO_TO_TEAM_REPORTS": "Перейти к отчетам по командам",
      "GO_TO_SETTINGS_AGENTS": "Перейти к настройкам сотрудников",
      "GO_TO_SETTINGS_TEAMS": "Перейти к настройкам команд",
      "GO_TO_SETTINGS_INBOXES": "Перейти к настройкам «Входящих»",
      "GO_TO_SETTINGS_LABELS": "Перейти к настройкам меток",
      "GO_TO_SETTINGS_CANNED_RESPONSES": "Перейти к настройкам шаблонных ответов",
      "GO_TO_SETTINGS_APPLICATIONS": "Перейти в настройки приложения",
      "GO_TO_SETTINGS_ACCOUNT": "Перейти в настройки учетной записи",
      "GO_TO_SETTINGS_PROFILE": "Перейти в настройки профиля",
      "GO_TO_NOTIFICATIONS": "Перейти к уведомлениям",
      "ADD_LABELS_TO_CONVERSATION": "Добавить метку в диалог",
      "ASSIGN_AN_AGENT": "Назначить сотрудника",
      "AI_ASSIST": "Помощь ИИ",
      "ASSIGN_PRIORITY": "Назначить приоритет",
      "ASSIGN_A_TEAM": "Назначить команду",
      "EXECUTE_A_MACRO": "Выполнить макрос",
      "MUTE_CONVERSATION": "Заглушить диалог",
      "UNMUTE_CONVERSATION": "Включить диалог",
      "REMOVE_LABEL_FROM_CONVERSATION": "Удалить метку из диалога",
      "REOPEN_CONVERSATION": "Переоткрыть разговор",
      "RESOLVE_CONVERSATION": "Решить разговор",
      "SEND_TRANSCRIPT": "Отправить историю переписки на email",
      "SNOOZE_CONVERSATION": "Включить звук диалога",
      "UNTIL_NEXT_REPLY": "До следующего ответа",
      "UNTIL_NEXT_WEEK": "До следующей недели",
      "UNTIL_TOMORROW": "До завтра",
      "UNTIL_NEXT_MONTH": "До следующего месяца",
      "AN_HOUR_FROM_NOW": "Еще через час",
      "UNTIL_CUSTOM_TIME": "Пользовательский...",
      "CHANGE_APPEARANCE": "Изменить внешний вид",
      "LIGHT_MODE": "Светлая",
      "DARK_MODE": "Тёмная",
      "SYSTEM_MODE": "Система",
      "SNOOZE_NOTIFICATION": "Отложить уведомление"
    }
  },
  "DASHBOARD_APPS": {
    "LOADING_MESSAGE": "Загрузка приложения панели управления..."
  },
  "COMMON": {
    "OR": "Или",
    "CLICK_HERE": "нажмите здесь"
  }
}
